import React from 'react';

export const Overview = ({ overview }) => <p>{overview}</p>
